import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

const TermsPage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navigation />

      <main className="flex-grow">
        {/* Header */}
        <div className="bg-black text-white py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl font-bold mb-4">Terms and Conditions</h1>
          </div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

          {/* Introduction */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Introduction</h2>
            <p className="text-gray-700 mb-3">
              Welcome to CrashChampions.com. This website is owned and operated by Crash Champions Collision Repair
              Centers. By visiting our website and accessing the information, resources, services, products, and tools
              we provide, you understand and agree to accept and adhere to the following terms and conditions as stated
              in this policy (hereafter referred to as 'User Agreement'), along with the terms and conditions as stated
              in our <Link to="/privacy" className="text-red-600 hover:underline">Privacy Policy</Link> (please refer
              to the Privacy Policy section for more information).
            </p>
            <p className="text-gray-700 mb-3">
              This agreement is in effect as of Aug 07, 2013.
            </p>
            <p className="text-gray-700">
              We reserve the right to change this User Agreement from time to time without notice. You acknowledge and
              agree that it is your responsibility to review this User Agreement periodically to familiarize yourself
              with any modifications. Your continued use of this site after such modifications will constitute
              acknowledgment and agreement of the modified terms and the conditions.
            </p>
          </section>

          {/* Responsible Use and Conduct */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Responsible Use and Conduct</h2>
            <p className="text-gray-700 mb-4">
              By visiting our website and accessing the information, resources, services, products, and tools we
              provide for you, either directly or indirectly (hereafter referred to as 'Resources'), you agree to use
              these Resources only for the purposes intended as permitted by (a) the terms of this User Agreement, and
              (b) applicable laws, regulations and generally accepted online practices or guidelines.
            </p>
            <p className="text-gray-700 mb-4">Wherein, you understand that:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-3 mb-4">
              <li>
                In order to access our Resources, you may be required to provide certain information about yourself
                (such as identification, contact details, etc.) as part of the registration process, or as part of your
                ability to use the Resources. You agree that any information you provide will always be accurate,
                correct, and up to date.
              </li>
              <li>
                You are responsible for maintaining the confidentiality of any login information associated with any
                account you use to access our Resources. Accordingly, you are responsible for all activities that occur
                under your account/s.
              </li>
              <li>
                Accessing (or attempting to access) any of our Resources by any means other than through the means we
                provide, is strictly prohibited. You specifically agree not to access (or attempt to access) any of our
                Resources through any automated, unethical or unconventional means.
              </li>
              <li>
                Engaging in any activity that disrupts or interferes with our Resources, including the servers and/or
                networks to which our Resources are located or connected, is strictly prohibited.
              </li>
              <li>
                Attempting to copy, duplicate, reproduce, sell, trade, or resell our Resources is strictly prohibited.
              </li>
              <li>
                You are solely responsible for any consequences, losses, or damages that we may directly or indirectly
                incur or suffer due to any unauthorized activities conducted by you, as explained above, and may incur
                criminal or civil liability.
              </li>
              <li>
                We may provide various open communication tools on our website, such as blog comments, blog posts,
                public chat, forums, message boards, newsgroups, product ratings and reviews, various social media
                services, etc. You understand that generally we do not pre-screen or monitor the content posted by users
                of these various communication tools, which means that if you choose to use these tools to submit any
                type of content to our website, then it is your personal responsibility to use these tools in a
                responsible and ethical manner. By posting information or otherwise using any open communication tools as
                mentioned, you agree that you will not upload, post, share, or otherwise distribute any content that:
                <ul className="list-disc list-inside ml-6 mt-2 space-y-1">
                  <li>
                    Is illegal, threatening, defamatory, abusive, harassing, degrading, intimidating, fraudulent,
                    deceptive, invasive, racist, or contains any type of suggestive, inappropriate, or explicit language;
                  </li>
                  <li>
                    Infringes on any trademark, patent, trade secret, copyright, or other proprietary right of any party;
                  </li>
                  <li>Contains any type of unauthorized or unsolicited advertising;</li>
                  <li>
                    Impersonates any person or entity, including any crashchampions.com employees or representatives.
                  </li>
                </ul>
              </li>
              <li>
                We do not assume any liability for any content posted by you or any other 3rd party users of our
                website. However, any content posted by you using any open communication tools on our website, provided
                that it doesn't violate or infringe on any 3rd party copyrights or trademarks, becomes the property of
                Crash Champions Collision Repair Centers, and as such, gives us a perpetual, irrevocable, worldwide,
                royalty-free, exclusive license to reproduce, modify, adapt, translate, publish, publicly display and/or
                distribute as we see fit. This only refers and applies to content posted via open communication tools as
                described, and does not refer to information that is provided as part of the registration process,
                necessary in order to use our Resources. All information provided as part of our registration process is
                covered by our <Link to="/privacy" className="text-red-600 hover:underline">Privacy Policy</Link>.
              </li>
              <li>
                You agree to indemnify and hold harmless Crash Champions Collision Repair Centers and its parent company
                and affiliates, and their directors, officers, managers, employees, donors, agents, and licensors, from
                and against all losses, expenses, damages and costs, including reasonable attorneys' fees, resulting from
                any violation of this User Agreement or the failure to fulfill any obligations relating to your account
                incurred by you or any other person using your account. We reserve the right to take over the exclusive
                defense of any claim for which we are entitled to indemnification under this User Agreement. In such
                event, you shall provide us with such cooperation as is reasonably requested by us.
              </li>
            </ul>
          </section>

          {/* Social Media Policy */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Social Media Policy</h2>
            <p className="text-gray-700 mb-4">
              We dearly care about our community and its individual users/members. So, in accordance with Facebook's
              terms and services, we reserve the right to delete user posted content at our discretion. Crash Champions
              will remove any of the following categories:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Abusive, disruptive, defamatory, profane or obscene</li>
              <li>Fraudulent, deceptive or misleading</li>
              <li>In violation of any intellectual property right of another</li>
              <li>In violation of any law or regulation</li>
              <li>In violation of a person's privacy; please do not state names</li>
              <li>Deliberately disruptive statements meant to hijack comment threads</li>
              <li>Otherwise offensive</li>
              <li>Promotional content</li>
            </ul>
            <p className="text-gray-700 mb-3">
              We also reserve the right to block persistently disruptive users. Please respect other users and our
              community.
            </p>
            <p className="text-gray-700">
              We recommend that all complaints and concerns not be handled publicly. We care about your privacy and
              your time.
            </p>
          </section>

          {/* SMS Policy */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">SMS Policy</h2>
            <ul className="list-disc list-inside text-gray-700 space-y-3">
              <li>
                By opting-in, Crash Champions will send opted-in users job opportunities. You will receive follow-up
                messages to filter the best options for you and will receive messages when there are new opportunities.
              </li>
              <li>This policy applies to all outgoing SMS messages for Crash Champions.</li>
              <li>
                You can cancel the SMS service at any time. Just text "STOP" to the short code. After you send the SMS
                message "STOP" to us, we will send you an SMS message to confirm that you have been unsubscribed. After
                this, you will no longer receive SMS messages from us. If you want to join again, just sign up as you
                did the first time and we will start sending SMS messages to you again.
              </li>
              <li>
                If you are experiencing issues with the messaging program you can reply with the keyword HELP for more
                assistance. Carriers are not liable for delayed or undelivered messages.
              </li>
              <li>
                As always, message and data rates may apply for any messages sent to you from us and to us from you.
                Message frequency may vary. If you have any questions about your text plan or data plan, it is best to
                contact your wireless provider.
              </li>
              <li>
                If you have any questions regarding privacy, please read our{' '}
                <Link to="/privacy" className="text-red-600 hover:underline">Privacy Policy</Link>.
              </li>
            </ul>
            <p className="text-gray-700 mt-4">Furthermore, you understand and agree that:</p>
            <ul className="list-disc list-inside text-gray-700 space-y-3 mt-2">
              <li>
                Any content downloaded or otherwise obtained through the use of our Resources is done at your own
                discretion and risk, and that you are solely responsible for any damage to your computer or other
                devices for any loss of data that may result from the download of such content.
              </li>
              <li>
                No information or advice, whether expressed, implied, oral or written, obtained by you from Crash
                Champions Collision Repair Centers or through any Resources we provide shall create any warranty,
                guarantee, or conditions of any kind, except for those expressly outlined in this User Agreement.
              </li>
            </ul>
          </section>

          {/* Limitation of Liability */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Limitation of Liability</h2>
            <p className="text-gray-700">
              In conjunction with the Limitation of Warranties as explained above, you expressly understand and agree
              that any claim against us shall be limited to the amount you paid, if any, for use of products and/or
              services. Crash Champions Collision Repair Centers will not be liable for any direct, indirect,
              incidental, consequential or exemplary loss or damages which may be incurred by you as a result of using
              our Resources, or as a result of any changes, data loss or corruption, cancellation, loss of access, or
              downtime to the full extent that applicable limitation of liability laws apply.
            </p>
          </section>

          {/* Copyrights/Trademarks */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Copyrights / Trademarks</h2>
            <p className="text-gray-700">
              All content and materials available on crashchampions.com, including but not limited to text, graphics,
              website name, code, images and logos are the intellectual property of Crash Champions Collision Repair
              Centers, and are protected by applicable copyright and trademark law. Any inappropriate use, including but
              not limited to the reproduction, distribution, display or transmission of any content on this site is
              strictly prohibited, unless specifically authorized by Crash Champions Collision Repair Centers.
            </p>
          </section>

          {/* Termination of Use */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Termination of Use</h2>
            <p className="text-gray-700">
              You agree that we may, at our sole discretion, suspend or terminate your access to all or part of our
              website and Resources with or without notice and for any reason, including, without limitation, breach of
              this User Agreement. Any suspected illegal, fraudulent or abusive activity may be grounds for terminating
              your relationship and may be referred to appropriate law enforcement authorities. Upon suspension or
              termination, your right to use the Resources we provide will immediately cease, and we reserve the right
              to remove or delete any information that you may have on file with us, including any account or login
              information.
            </p>
          </section>

          {/* Governing Law */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Governing Law</h2>
            <p className="text-gray-700">
              This website is controlled by Crash Champions Collision Repair Centers from our offices located in the
              state of Texas, USA. It can be accessed by most countries around the world. As each country has laws that
              may differ from those of Texas, by accessing our website, you agree that the statutes and laws of Texas,
              without regard to the conflict of laws and the United Nations Convention on the International Sales of
              Goods, will apply to all matters relating to the use of this website and the purchase of any products or
              services through this site.
            </p>
            <p className="text-gray-700 mt-3">
              Furthermore, any action to enforce this User Agreement shall be brought in the federal or state courts
              located in Texas, USA. You hereby agree to personal jurisdiction by such courts and waive any
              jurisdictional, venue, or inconvenient forum objections to such courts.
            </p>
          </section>

          {/* Guarantee */}
          <section className="mb-10">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Guarantee</h2>
            <p className="text-gray-700 uppercase font-semibold">
              Unless otherwise expressed, Crash Champions Collision Repair Centers expressly disclaims all warranties
              and conditions of any kind, whether express or implied, including, but not limited to the implied
              warranties and conditions of merchantability, fitness for a particular purpose and non-infringement.
            </p>
          </section>

          {/* Contact Information */}
          <section className="bg-black text-white rounded-lg p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
            <p className="text-gray-300 mb-2">
              If you have any questions or comments about these Terms and Conditions, you can contact us at:
            </p>
            <p className="text-gray-300 mb-1 font-semibold">Crash Champions Collision Repair Centers</p>
            <p className="text-gray-300 mb-1">601 Oakmont Lane</p>
            <p className="text-gray-300 mb-1">Westmont, Illinois 60559</p>
            <p className="text-gray-300 mb-4">T: (877) 846-9500</p>
            <a
              href="https://www.crashchampions.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-red-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-700 transition-colors"
            >
              www.crashchampions.com
            </a>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
